import { FC } from 'react';
import styles from '../../styles/components/buttongroup.module.scss';

const ButtonGroup: FC = ({ children }) => {
  return <div className={styles.wrapper}>{children}</div>;
};

export default ButtonGroup;
